import React from 'react';
import Table from 'react-bootstrap/Table';

const H2hMiniTable = ({
  h2hData,
  getBookLogoUrl,
  getTeamLogoUrl,
  getCellStyle,
  getTooltipText,
  onOddsClick,
  game,
  periodsToShow = null  // If null, show all periods. Otherwise, array of periods to display
}) => {
  const safeGame = { away: 'TBD', home: 'TBD', gameIDmlb: 'loading', ...game };

  if (!h2hData || h2hData.length === 0) {
    return null;
  }

  // Group players by period
  const groupedByPeriod = h2hData.reduce((acc, player) => {
    const period = player.period || 'Game';
    if (!acc[period]) {
      acc[period] = [];
    }
    acc[period].push(player);
    return acc;
  }, {});

  // Define period order
  const periodOrder = ['Game', 'Q1', 'Q2', 'Q3', 'Q4', '1st Half', '2nd Half', '1st', '2nd', '3rd'];

  // Filter periods based on periodsToShow prop
  let periodsToDisplay = Object.keys(groupedByPeriod);
  if (periodsToShow && Array.isArray(periodsToShow)) {
    periodsToDisplay = periodsToDisplay.filter(period => periodsToShow.includes(period));
  }

  const sortedPeriods = periodsToDisplay.sort((a, b) => {
    const indexA = periodOrder.indexOf(a);
    const indexB = periodOrder.indexOf(b);
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  // Function to find best odds for a player
  const findBestOdds = (player) => {
    const books = ['fanduel', 'draftkings', 'betmgm', 'caesars', 'bet365', 'pointsbet', 'betrivers', 'hardrockbet', 'bovada', 'fanatics', 'espnbet'];
    let bestOdds = null;
    let bestBook = null;
    let bookCount = 0;

    books.forEach(book => {
      const odds = player[`h2h_${book}`];
      if (odds !== null && odds !== undefined) {
        bookCount++;
        if (bestOdds === null || odds > bestOdds) {
          bestOdds = odds;
          bestBook = book;
        }
      }
    });

    const bestBookPrice = player.h2h_bestBookPrice;
    const bestBookDiff = player.h2h_bestBookDiff;

    return { bestOdds, bestBook, bestBookPrice, bestBookDiff, bookCount };
  };

  return (
    <div className="table-container" style={{ width: '50%' }}>
      <Table bordered size="sm" className="text-center">
        <tbody>
          {sortedPeriods.map((period) => {
            // Group by team for this period and keep only one entry per team
            const periodData = groupedByPeriod[period];
            const uniqueTeams = {};

            periodData.forEach(player => {
              const teamKey = player.team;
              if (!uniqueTeams[teamKey]) {
                uniqueTeams[teamKey] = player;
              }
            });

            return (
              <React.Fragment key={period}>
                {/* Period section header */}
                <tr>
                  <td colSpan={2} style={{
                    backgroundColor: 'transparent',
                    color: '#ffc107',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    padding: '8px',
                    borderTop: 'none',
                    borderBottom: 'none',
                    height: '40px'
                  }}>
                    {period === 'Game' ? 'Moneyline' : `Moneyline ${period}`}
                  </td>
                </tr>
                {/* Teams for this period */}
                {Object.values(uniqueTeams).map((player) => {
                  const { bestOdds, bestBook, bestBookPrice, bestBookDiff, bookCount } = findBestOdds(player);

                  return (
                    <tr key={player.tierKey || player.id}>
                    <td style={{ width: '120px', fontWeight: 'bold' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                        {player.team !== 'draw' && (
                          <img
                            src={player.team === 'away' ? safeGame.awayLogo : safeGame.homeLogo}
                            alt={player.team === 'away' ? safeGame.away : safeGame.home}
                            style={{ width: '20px', height: '20px' }}
                            onError={(e) => {
                              e.target.style.visibility = 'hidden';
                              e.target.style.width = '0px';
                              e.target.style.height = '0px';
                              e.target.style.margin = '0px';
                            }}
                          />
                        )}
                        <span>
                          {player.team === 'draw'
                            ? 'Draw'
                            : player.team === 'away'
                              ? (safeGame.awayNickname || safeGame.away)
                              : (safeGame.homeNickname || safeGame.home)
                          }
                        </span>
                      </div>
                    </td>
                    <td
                      style={{
                        ...getCellStyle(bestOdds, bestBookPrice, bestBookDiff, bookCount),
                        textAlign: 'center',
                        padding: '8px 4px',
                        cursor: bestOdds ? 'pointer' : 'default'
                      }}
                      title={getTooltipText(bestOdds, bestBookPrice, bestBookDiff, bookCount)}
                      onClick={() => {
                        if (bestOdds && bestBook && onOddsClick) {
                          onOddsClick(safeGame.gameIDmlb, null, player.team, 'h2h', bestBook, bestOdds, safeGame.away, safeGame.home);
                        }
                      }}
                    >
                      {bestOdds !== null && bestBook ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                          <img
                            src={getBookLogoUrl(bestBook)}
                            alt={bestBook}
                            style={{ height: '16px', width: 'auto' }}
                          />
                          <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                            {bestOdds > 0 ? `+${bestOdds}` : bestOdds}
                          </span>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                  );
                })}
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default H2hMiniTable;
